import React from 'react';
import PropTypes from 'prop-types';


class SelectControl extends React.Component {

  static propTypes = {
    value: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    prompt: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
  };

  render() {
    const {options, onChange, value, prompt} = this.props;
    return (
      <select value={value} onChange={onChange}>
        <option key={0} value="">{prompt}</option>
        {options.map((option, idx) => {
          return (<option key={idx+1} value={option.value}>{option.label}</option>);
        })}
      </select>
    );
  }
}

export default SelectControl;



// WEBPACK FOOTER //
// ./src/views/fragments/select-control/index.js